import { AiFillPayCircle, AiOutlineInsurance } from "react-icons/ai";
import HomeImg from "../../../../../assets/icons/HrIcons/Home.png";

import EmployeeManagementImg from "../../../../../assets/icons/HrIcons/EmployeeManagement.png";
import EmployeeMasterImg from "../../../../../assets/icons/HrIcons/EmployeeMaster.png";
import EmployeeOrganizationImg from "../../../../../assets/icons/HrIcons/EmployeeOrganization.png";

import TimeManagementImg from "../../../../../assets/icons/HrIcons/TimeManagement.png";
import DeviceAttendanceImg from "../../../../../assets/icons/HrIcons/DeviceAttendance.png";
import DeviceConfigurationImg from "../../../../../assets/icons/HrIcons/DeviceConfiguration.png";
import ImportAttendanceImg from "../../../../../assets/icons/HrIcons/ImportAttendance.png";
import TimesheetAttendanceImg from "../../../../../assets/icons/HrIcons/TimesheetAttendance.png";
import TimesheetImg from "../../../../../assets/icons/HrIcons/Timesheet.png";
import CreateAttendanceImg from "../../../../../assets/icons/HrIcons/CreateAttendance.png";
import ESSAttendanceImg from "../../../../../assets/icons/HrIcons/ESSAttendance.png";
import CheckInStatusImg from "../../../../../assets/icons/HrIcons/CheckInStatus.png";
import ProcessAttendanceImg from "../../../../../assets/icons/HrIcons/ProcessAttendance.png";

import LeaveManagementImg from "../../../../../assets/icons/HrIcons/LeaveManagement.png";
import LeaveTypeImg from "../../../../../assets/icons/HrIcons/LeaveType.png";
import LeaveBalanceImg from "../../../../../assets/icons/HrIcons/LeaveBalance.png";
import LeavePositionImg from "../../../../../assets/icons/HrIcons/LeavePosition.png";
import LeaveCalendarImg from "../../../../../assets/icons/HrIcons/LeaveCalendar.png";
import LeaveCancellationImg from "../../../../../assets/icons/HrIcons/LeaveCancellation.png";

import PayrollManagementImg from "../../../../../assets/icons/HrIcons/PayrollManagement.png";
import PayrollSettingsImg from "../../../../../assets/icons/HrIcons/PayrollSettings.png";
import PaySetupImg from "../../../../../assets/icons/HrIcons/PaySetup.png";
import PayrollCalendarImg from "../../../../../assets/icons/HrIcons/PayrollCalendar.png";
import PayConfigurationImg from "../../../../../assets/icons/HrIcons/PayConfiguration.png";
import StatutoryComponentsImg from "../../../../../assets/icons/HrIcons/StatutoryComponents.png";
import ProvidentFundImg from "../../../../../assets/icons/HrIcons/ProvidentFund.png";
import SalaryComponentImg from "../../../../../assets/icons/HrIcons/SalaryComponent.png";
import EarningsImg from "../../../../../assets/icons/HrIcons/Earnings.png";
import DeductionsImg from "../../../../../assets/icons/HrIcons/Deductions.png";

import CreatePayrollImg from "../../../../../assets/icons/HrIcons/CreatePayroll.png";
import VariableEarningImg from "../../../../../assets/icons/HrIcons/VariableEarning.png";
import VariableDeductionImg from "../../../../../assets/icons/HrIcons/VariableDeduction.png";
import ReverseLopImg from "../../../../../assets/icons/HrIcons/ReverseLop.png";
import ProcessPayrollImg from "../../../../../assets/icons/HrIcons/ProcessPayroll.png";
import PayslipSummaryImg from "../../../../../assets/icons/HrIcons/PayslipSummary.png";
import PayslipsImg from "../../../../../assets/icons/HrIcons/Payslips.png";
import PayrollJournalsImg from "../../../../../assets/icons/HrIcons/PayrollJournals.png";

import IncomeTaxImg from "../../../../../assets/icons/HrIcons/IncomeTax.png";
import TaxSlabImg from "../../../../../assets/icons/HrIcons/TaxSlab.png";
import TaxSectionImg from "../../../../../assets/icons/HrIcons/TaxSection.png";
import TaxExemptionImg from "../../../../../assets/icons/HrIcons/TaxExemption.png";
import TaxDeductionImg from "../../../../../assets/icons/HrIcons/TaxDeduction.png";
import TaxDeclarationImg from "../../../../../assets/icons/HrIcons/TaxDeclaration.png";
import TaxCalculationImg from "../../../../../assets/icons/HrIcons/TaxCalculation.png";

import AppraisalImg from "../../../../../assets/icons/HrIcons/Appraisal.png";
import GoalsImg from "../../../../../assets/icons/HrIcons/Goals.png";
import KpiImg from "../../../../../assets/icons/HrIcons/Kpi.png";
import GoalSettingsImg from "../../../../../assets/icons/HrIcons/GoalSettings.png";
import PerformanceAppraisalImg from "../../../../../assets/icons/HrIcons/PerformanceAppraisal.png";
import FinalEvaluationImg from "../../../../../assets/icons/HrIcons/FinalEvaluation.png";
import PerformanceImprovementImg from "../../../../../assets/icons/HrIcons/PerformanceImprovement.png";

import TrainingImg from "../../../../../assets/icons/HrIcons/Training.png";
import TrainingDetailsImg from "../../../../../assets/icons/HrIcons/TrainingDetails.png";
import TrainerInformationImg from "../../../../../assets/icons/HrIcons/TrainerInformation.png";
import TrainingScheduleImg from "../../../../../assets/icons/HrIcons/TrainingSchedule.png";
import TargetAudienceImg from "../../../../../assets/icons/HrIcons/TargetAudience.png";
import TrainingContentImg from "../../../../../assets/icons/HrIcons/TrainingContent.png";
import TrainingAttendanceImg from "../../../../../assets/icons/HrIcons/TrainingAttendance.png";
import TrainingFeedbackImg from "../../../../../assets/icons/HrIcons/TrainingFeedback.png";
import TrainingBudgetImg from "../../../../../assets/icons/HrIcons/TrainingBudget.png";

import ReimbursementImg from "../../../../../assets/icons/HrIcons/Reimbursement.png";

import EmployeeExitImg from "../../../../../assets/icons/HrIcons/EmployeeExit.png";
import ResignationImg from "../../../../../assets/icons/HrIcons/Resignation.png";
import FullandFinalImg from "../../../../../assets/icons/HrIcons/FullandFinal.png";

import ReportsImg from "../../../../../assets/icons/HrIcons/Reports.png";
import EmployeeAdditionImg from "../../../../../assets/icons/HrIcons/EmployeeAddition.png";
import EmployeeAttritionImg from "../../../../../assets/icons/HrIcons/EmployeeAttrition.png";
import ESIReportImg from "../../../../../assets/icons/HrIcons/ESIReport.png";
import EmployeeAddressImg from "../../../../../assets/icons/HrIcons/EmployeeAddress.png";
import CashStatementImg from "../../../../../assets/icons/HrIcons/CashStatement.png";
import GrossSalaryImg from "../../../../../assets/icons/HrIcons/GrossSalary.png";

import { HiReceiptTax } from "react-icons/hi";

// For user admin
import EmailImg from "../../../../../assets/icons/HrIcons/Email.png";

import RequestImg from "../../../../../assets/icons/HrIcons/Request.png";
import AdditionalLicenseImg from "../../../../../assets/icons/HrIcons/AdditionalLicense.png";
import AdditionalStorageImg from "../../../../../assets/icons/HrIcons/AdditionalStorage.png";
import AddonPurchaseImg from "../../../../../assets/icons/HrIcons/AddonPurchase.png";
import CancelPlanImg from "../../../../../assets/icons/HrIcons/CancelPlan.png";
import RenewalImg from "../../../../../assets/icons/HrIcons/Renewal.png";

import TaskManagementImg from "../../../../../assets/icons/HrIcons/TaskManagement.png";
import ListTaskImg from "../../../../../assets/icons/HrIcons/ListTask.png";
import TaskCalendarImg from "../../../../../assets/icons/HrIcons/TaskCalendar.png";

import SettingsImg from "../../../../../assets/icons/HrIcons/Settings.png";
import CompanyDetailsImg from "../../../../../assets/icons/HrIcons/CompanyDetails.png";
import RolesImg from "../../../../../assets/icons/HrIcons/Roles.png";
import InviteUserImg from "../../../../../assets/icons/HrIcons/InviteUser.png";
import DepartmentImg from "../../../../../assets/icons/HrIcons/Department.png";
import CadreLevelImg from "../../../../../assets/icons/HrIcons/CadreLevel.png";
import DesignationImg from "../../../../../assets/icons/HrIcons/Designation.png";
import HolidaysImg from "../../../../../assets/icons/HrIcons/Holidays.png";
import PreferenceImg from "../../../../../assets/icons/HrIcons/Preference.png";
import TransactionSeriesImg from "../../../../../assets/icons/HrIcons/TransactionSeries.png";
import LookupImg from "../../../../../assets/icons/HrIcons/Lookup.png";
import CostCentreImg from "../../../../../assets/icons/HrIcons/CostCentre.png";
import AccountPeriodImg from "../../../../../assets/icons/HrIcons/AccountPeriod.png";
import YearEndProcessImg from "../../../../../assets/icons/HrIcons/YearEndProcess.png";
import TDSSetupImg from "../../../../../assets/icons/HrIcons/TDSSetup.png";
import WorkflowImg from "../../../../../assets/icons/HrIcons/Workflow.png";
import { RiMailCheckLine } from "react-icons/ri";
import { LuBaggageClaim, LuUserX } from "react-icons/lu";
import { LuAlarmClock } from "react-icons/lu";

export const SidebarIcons = {
  HomeIcon: (
    <img src={HomeImg} alt="Home" style={{ width: 17, marginLeft: "-15px" }} />
  ),

  EmployeeManagementIcon: (
    <img
      src={EmployeeManagementImg}
      alt="Employee Management"
      style={{ width: 17 }}
    />
  ),
  EmployeeMasterIcon: (
    <img
      src={EmployeeMasterImg}
      alt="Employee Master"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  EmployeeOrganizationIcon: (
    <img
      src={EmployeeOrganizationImg}
      alt="Employee Organization"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  TimeManagementIcon: (
    <img src={TimeManagementImg} alt="Time Management" style={{ width: 16 }} />
  ),
  DeviceAttendanceIcon: (
    <img
      src={DeviceAttendanceImg}
      alt="Device Attendance"
      style={{ width: 15, marginLeft: "20px", marginRight: "15px" }}
    />
  ),
  DeviceConfigurationIcon: (
    <img
      src={DeviceConfigurationImg}
      alt="Device Configuration"
      style={{ width: 15, marginLeft: "20px" }}
    />
  ),
  ImportAttendanceIcon: (
    <img
      src={ImportAttendanceImg}
      alt="Import Attendance"
      style={{ width: 15, marginLeft: "20px" }}
    />
  ),

  TimesheetAttendanceIcon: (
    <img
      src={TimesheetAttendanceImg}
      alt="Timesheet Attendance"
      style={{ width: 15, marginLeft: "3px" }}
    />
  ),
  TimesheetIcon: (
    <img
      src={TimesheetImg}
      alt="Timesheet"
      style={{ width: 15, marginLeft: "20px" }}
    />
  ),
  CreateAttendanceIcon: (
    <img
      src={CreateAttendanceImg}
      alt="Create Attendance"
      style={{ width: 15, marginLeft: "3px" }}
    />
  ),

  ESSAttendanceIcon: (
    <img
      src={ESSAttendanceImg}
      alt="ESS Attendance"
      style={{ width: 17, marginLeft: "3px" }}
    />
  ),
  // CheckInStatusIcon: <i class="fa-solid fa-fingerprint" style={{ fontSize: 16, color: "#01788c", marginLeft: "3px" }}></i>,
  CheckInStatusIcon: (
    <img
      src={CheckInStatusImg}
      alt="Checkin Status"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  AbsentEmployeesIcon: (
  <LuUserX
    style={{
      fontSize: 18,
      marginLeft: "3px",
      color: "#01788c",
      
    }}
  />
),

  ProcessAttendanceIcon: (
    <img
      src={ProcessAttendanceImg}
      alt="Process Attendance"
      style={{ width: 17, marginLeft: "3px" }}
    />
  ),
  LateCheckinIcon: (
    <LuAlarmClock
      style={{
        fontSize: 18,
        marginLeft: "3px",
        color: "#01788c",
      }}
    />
  ),

  LeaveManagementIcon: (
    <img
      src={LeaveManagementImg}
      alt="Leave Management"
      style={{ width: 16 }}
    />
  ),
  LeaveTypeIcon: (
    <img
      src={LeaveTypeImg}
      alt="Leave Type"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  LeaveBalanceIcon: (
    <img
      src={LeaveBalanceImg}
      alt="Leave Balance"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  LeavePositionIcon: (
    <img
      src={LeavePositionImg}
      alt="Leave Position"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  LeaveCalendarIcon: (
    <img
      src={LeaveCalendarImg}
      alt="Leave Calendar"
      style={{ width: 17, marginLeft: "3px" }}
    />
  ),
  LeaveCancellationIcon: (
    <img
      src={LeaveCancellationImg}
      alt="Leave Cancellation"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  PayrollManagementIcon: (
    <img
      src={PayrollManagementImg}
      alt="Payroll Management"
      style={{ width: 16 }}
    />
  ),
  PayrollSettingIcon: (
    <img
      src={PayrollSettingsImg}
      alt="Payroll Setting"
      style={{ width: 16, marginLeft: "20px", marginRight: "15px" }}
    />
  ),
  PaySetupIcon: (
    <img
      src={PaySetupImg}
      alt="Pay Setup"
      style={{ width: 16, marginLeft: "15px" }}
    />
  ),
  PayrollCalendarIcon: (
    <img
      src={PayrollCalendarImg}
      alt="Payroll Calendar"
      style={{ width: 16, marginLeft: "15px" }}
    />
  ),
  PayConfigurationIcon: (
    <img
      src={PayConfigurationImg}
      alt="Pay Configuration"
      style={{ width: 16, marginLeft: "15px" }}
    />
  ),
  StatutoryIcon: (
    <i
      className="fa-brands fa-square-web-awesome"
      style={{
        fontSize: 18,
        color: "#01788c",
        marginLeft: "30px",
        marginRight: "15px",
      }}
    ></i>
  ),
  StatutoryAdminIcon: (
    <i
      className="fa-brands fa-square-web-awesome"
      style={{
        fontSize: 18,
        color: "#01788c",
        marginLeft: "20px",
        marginRight: "15px",
      }}
    ></i>
  ),
  StatutoryComponentsIcon: (
    <img
      src={StatutoryComponentsImg}
      alt="Statutory Components"
      style={{ width: 16, marginLeft: "15px" }}
    />
  ),
  ProvidentFundIcon: (
    <img
      src={ProvidentFundImg}
      alt="Provident Fund"
      style={{ width: 16, marginLeft: "25px" }}
    />
  ),
  ESIIcon: (
    <AiOutlineInsurance
      style={{ fontSize: 16, marginLeft: 25, color: "#01788c" }}
    />
  ),
  ProfessionalTaxIcon: (
    <HiReceiptTax style={{ fontSize: 16, marginLeft: 25, color: "#01788c" }} />
  ),
  StatutoryComponentsIcon: (
    <img
      src={StatutoryComponentsImg}
      alt="Statutory Components"
      style={{ width: 16, marginLeft: "15px" }}
    />
  ),
  SalaryComponentIcon: (
    <img
      src={SalaryComponentImg}
      alt="Salary Component"
      style={{ width: 16, marginLeft: "30px", marginRight: "15px" }}
    />
  ),
  SalaryComponentAdminIcon: (
    <img
      src={SalaryComponentImg}
      alt="Salary Component"
      style={{ width: 16, marginLeft: "40px", marginRight: "15px" }}
    />
  ),
  EarningsIcon: (
    <img
      src={EarningsImg}
      alt="Earnings"
      style={{ width: 16, marginLeft: "25px" }}
    />
  ),
  DeductionsIcon: (
    <img
      src={DeductionsImg}
      alt="Deductions"
      style={{ width: 16, marginLeft: "25px" }}
    />
  ),

  CreatePayrollIcon: (
    <img
      src={CreatePayrollImg}
      alt="Create Payroll"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  VariableEarningIcon: (
    <img
      src={VariableEarningImg}
      alt="Variable Earning"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  VariableDeductionIcon: (
    <img
      src={VariableDeductionImg}
      alt="Variable Deduction"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  ReverseLopIcon: (
    <img
      src={ReverseLopImg}
      alt="Reverse Lop"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  ProcessPayrollIcon: (
    <img
      src={ProcessPayrollImg}
      alt="Process Payroll"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  PayslipSummaryIcon: (
    <img
      src={PayslipSummaryImg}
      alt="Payslip Summary"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  PayslipsIcon: (
    <img
      src={PayslipsImg}
      alt="Payslip"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),
  PayrollJournalsIcon: (
    <img
      src={PayrollJournalsImg}
      alt="Payroll Journals"
      style={{ width: 18, marginLeft: "3px" }}
    />
  ),

  IncomeTaxIcon: (
    <img src={IncomeTaxImg} alt="Income Tax" style={{ width: 16 }} />
  ),
  TaxSlabIcon: (
    <img
      src={TaxSlabImg}
      alt="Tax Slab"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TaxSectionIcon: (
    <img
      src={TaxSectionImg}
      alt="Tax Section"
      style={{ width: 17, marginLeft: "3px" }}
    />
  ),
  TaxExemptionIcon: (
    <img
      src={TaxExemptionImg}
      alt="Tax Exemption"
      style={{ width: 17, marginLeft: "3px" }}
    />
  ),
  TaxDeductionIcon: (
    <img
      src={TaxDeductionImg}
      alt="Tax Deduction"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TaxDeclarationIcon: (
    <img
      src={TaxDeclarationImg}
      alt="Tax Declaration"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TaxCalculationIcon: (
    <img
      src={TaxCalculationImg}
      alt="Tax Calculation"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  AppraisalIcon: (
    <img src={AppraisalImg} alt="Appraisal" style={{ width: 16 }} />
  ),
  GoalsIcon: (
    <img src={GoalsImg} alt="Goals" style={{ width: 16, marginLeft: "3px" }} />
  ),
  KpiIcon: (
    <img src={KpiImg} alt="Kpi" style={{ width: 16, marginLeft: "3px" }} />
  ),
  GoalSettingsIcon: (
    <img
      src={GoalSettingsImg}
      alt="Goal Settings"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  PerformanceAppraisalIcon: (
    <img
      src={PerformanceAppraisalImg}
      alt="Performance Appraisal"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  FinalEvaluationIcon: (
    <img
      src={FinalEvaluationImg}
      alt="Final Evaluation"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  PerformanceImprovementIcon: (
    <img
      src={PerformanceImprovementImg}
      alt="Performance Improvement"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  TrainingIcon: <img src={TrainingImg} alt="Training" style={{ width: 16 }} />,
  TrainingDetailsIcon: (
    <img
      src={TrainingDetailsImg}
      alt="Training Details"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainerInformationIcon: (
    <img
      src={TrainerInformationImg}
      alt="Trainer Information"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainingScheduleIcon: (
    <img
      src={TrainingScheduleImg}
      alt="Training Schedule"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TargetAudienceIcon: (
    <img
      src={TargetAudienceImg}
      alt="Target Audience"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainingContentIcon: (
    <img
      src={TrainingContentImg}
      alt="Training Content"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainingAttendanceIcon: (
    <img
      src={TrainingAttendanceImg}
      alt="Training Attendance"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainingFeedbackIcon: (
    <img
      src={TrainingFeedbackImg}
      alt="Training Feedback"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TrainingBudgetIcon: (
    <img
      src={TrainingBudgetImg}
      alt="Training Budget"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  ReimbursementIcon: (
    <img
      src={ReimbursementImg}
      alt="Reimbursement"
      style={{ width: 18, marginLeft: "-15px" }}
    />
  ),
  ClaimIcon: (
    <LuBaggageClaim
      style={{ color: "#3fa3b7ff", fontSize: 18, marginLeft: "-15px" }}
    />
  ),

  // EmployeeExitIcon: <FaUsersCog style={{ fontSize: 18, color: "#01788c" }} />,
  EmployeeExitIcon: (
    <img src={EmployeeExitImg} alt="Employee Exit" style={{ width: 16 }} />
  ),
  ResignationIcon: (
    <img
      src={ResignationImg}
      alt="Resignation"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  FullandFinalIcon: (
    <img
      src={FullandFinalImg}
      alt="Full and Final"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  ReportsIcon: <img src={ReportsImg} alt="Reports" style={{ width: 16 }} />,
  EmployeeAdditionIcon: (
    <img
      src={EmployeeAdditionImg}
      alt="Employee Addition Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  EmployeeAttritionIcon: (
    <img
      src={EmployeeAttritionImg}
      alt="Employee Attrition Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  ESIReportIcon: (
    <img
      src={ESIReportImg}
      alt="ESI Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  EmployeeAddressIcon: (
    <img
      src={EmployeeAddressImg}
      alt="Employee Address Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  CashStatementIcon: (
    <img
      src={CashStatementImg}
      alt="Cash Statement Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  GrossSalaryIcon: (
    <img
      src={GrossSalaryImg}
      alt="Gross Salary Report"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  // For User Admin
  UserAdminHomeIcon: (
    <img src={HomeImg} alt="Home" style={{ width: 17, marginLeft: "-15px" }} />
  ),
  EmailIcon: (
    <img
      src={EmailImg}
      alt="Email"
      style={{ width: 17, marginLeft: "-15px" }}
    />
  ),

  RequestIcon: <img src={RequestImg} alt="Request" style={{ width: 16 }} />,
  AdditionalLicenseIcon: (
    <img
      src={AdditionalLicenseImg}
      alt="Additional License"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  AdditionalStorageIcon: (
    <img
      src={AdditionalStorageImg}
      alt="Additional Storage"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  AddonPurchaseIcon: (
    <img
      src={AddonPurchaseImg}
      alt="Addon Purchase"
      style={{ width: 16, marginLeft: "2px" }}
    />
  ),
  CancelPlanIcon: (
    <img
      src={CancelPlanImg}
      alt="Cancel Plan"
      style={{ width: 15, marginLeft: "3px" }}
    />
  ),
  RenewalIcon: (
    <img
      src={RenewalImg}
      alt="Renewal"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  TaskManagementIcon: (
    <img src={TaskManagementImg} alt="Task Management" style={{ width: 17 }} />
  ),
  ListTaskIcon: (
    <img
      src={ListTaskImg}
      alt="List Task"
      style={{ width: 15, marginLeft: "3px" }}
    />
  ),
  TaskCalendarIcon: (
    <img
      src={TaskCalendarImg}
      alt="Task Calendar"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),

  SettingsIcon: <img src={SettingsImg} alt="Settings" style={{ width: 17 }} />,
  CompanyDetailsIcon: (
    <img
      src={CompanyDetailsImg}
      alt="Company Details"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  RolesIcon: (
    <img src={RolesImg} alt="Roles" style={{ width: 16, marginLeft: "3px" }} />
  ),
  UserIcon: (
    <img
      src={InviteUserImg}
      alt="Invite User"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  DepartmentIcon: (
    <img
      src={DepartmentImg}
      alt="Department"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  CadreIcon: (
    <img
      src={CadreLevelImg}
      alt="CadreLevel"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  DesignationIcon: (
    <img
      src={DesignationImg}
      alt="Designation"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  HolidaysIcon: (
    <img
      src={HolidaysImg}
      alt="Holidays"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  PreferenceIcon: (
    <img
      src={PreferenceImg}
      alt="Preference"
      style={{ width: 17, marginLeft: "20px", marginRight: "15px" }}
    />
  ),
  TransactionSeriesIcon: (
    <img
      src={TransactionSeriesImg}
      alt="Transaction Series"
      style={{ width: 16, marginLeft: "20px" }}
    />
  ),
  MailConfigurationIcon: (
    <RiMailCheckLine
      style={{ color: "#3fa3b7ff", fontSize: 18, marginLeft: "20px" }}
    />
  ),
  LookupIcon: (
    <img
      src={LookupImg}
      alt="Lookup"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  CostCentreIcon: (
    <img
      src={CostCentreImg}
      alt="CostCentre"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  AccountPeriodIcon: (
    <img
      src={AccountPeriodImg}
      alt="Account Period"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  YearEndProcessIcon: (
    <img
      src={YearEndProcessImg}
      alt="Year End Process"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  TDSSetupIcon: (
    <img
      src={TDSSetupImg}
      alt="TDS Setup"
      style={{ width: 16, marginLeft: "3px" }}
    />
  ),
  WorkflowIcon: (
    <img
      src={WorkflowImg}
      alt="Workflow"
      style={{ width: 16, marginLeft: "20px", marginRight: "15px" }}
    />
  ),
  WorkflowRuleIcon: (
    <img
      src={WorkflowImg}
      alt="Workflow"
      style={{ width: 16, marginLeft: "20px" }}
    />
  ),
};
